import { render, staticRenderFns } from "./ContatoView.vue?vue&type=template&id=2fdadc90&"
import script from "./ContatoView.vue?vue&type=script&lang=js&"
export * from "./ContatoView.vue?vue&type=script&lang=js&"
import style0 from "./ContatoView.vue?vue&type=style&index=0&id=2fdadc90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports